module.exports = __webpack_public_path__ + "media/icons/buildings-31a0f8c5.png";